<template>
  <question-base-wrapper v-bind="baseWrapperProps">
    <validation-provider
      v-slot="{ failedRules, failed }"
      :rules="validationRules ? validationRules['field'] : 'required'"
      :name="questionId"
      :vid="`${stepId}_${questionId}`"
      :data-unit-test="`${stepId}_${questionId}`"
    >
      <radio
        v-model="questionData[questionFields.field]"
        :name="`${stepId}.${questionId}`"
        :items="options"
        :error="failed"
        :error-messages="getFieldErrors('field', failedRules)"
        :data-test="snakeCase(questionFields.field)"
      />
    </validation-provider>
  </question-base-wrapper>
</template>

<script>
import createOptions from '@/utils/createOptions';
import QuestionBase from './Base';
import QuestionBaseWrapper from './BaseWrapper';

export default {
  name: 'question-base-radio-boolean',
  extends: QuestionBase,
  components: { QuestionBaseWrapper },
  data () {
    return { fields: ['field'] };
  },
  computed: {
    options () {
      if (this.optionsConfig?.options) {
        return createOptions({ source: this.optionsConfig.options });
      }
      return this.constants.YES_NO;
    },
  },
};
</script>
